import { getUserCondition } from 'modules/user/utils';
import { DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE } from 'modules/questionnaire/constants';

export const profileToQuestionnaireParameters = (profile) => {
  const disease = getUserCondition(profile);
  if (!disease) {
    return null;
  }
  const { condition_profile: conditionProfile } = profile;
  const diseaseSubTypeField = DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE[disease];
  const diseaseSubTypeValue = conditionProfile?.[DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE[disease]];
  const additionalParams = diseaseSubTypeValue ? { diseaseSubTypeField, diseaseSubTypeValue } : {};
  return [disease, additionalParams];
};
